export default __webpack_public_path__ + "static/media/cancel.51cefdbf.svg";